export default __webpack_public_path__ + "static/media/gun-traders-twc-40x40.8e3bb8d0.webp";